import { getPayorConfig } from "@utils/payorConfig";
import React from "react";

import { Dialog, Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

import { ApiReportTemplatePayorTypeChoices } from "@api/graphql/types-and-hooks";
import { Loader } from "@components/ClinicalNewReportDialog/Loader";

interface PayorSubmittingDialogProps {
  open: boolean;
  payorType: ApiReportTemplatePayorTypeChoices | null | undefined;
}

export const PayorSubmittingDialog: React.FC<PayorSubmittingDialogProps> = ({ open, payorType }) => {
  const copy = getPayorConfig(payorType);
  if (!copy) return null;

  return (
    <Dialog
      open={open}
      setOpen={() => {}}
      title={
        <Headline as="h3" size="extra-small" colorType="primary">
          {copy.submittingDialog.title}
        </Headline>
      }
      size="sm"
      showCloseButton={false}
      primaryButton={undefined}
      secondaryButton={undefined}
      bodyClassName="pb-6"
      dialogClassName="!max-w-[390px] sm:!max-w-[390px]"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <Loader className="ml-0 mr-0 h-[22px] w-[22px] text-limestone-400" />
          <Paragraph size="medium" colorType="secondary">
            Report submission in progress...
          </Paragraph>
        </div>
        <div className="flex w-full items-center justify-center rounded-lg bg-limestone-50 p-2">
          <Paragraph size="extra-small" colorType="secondary" className="flex-1">
            This may take a few minutes, please do not close this window.
          </Paragraph>
        </div>
      </div>
    </Dialog>
  );
};
